import React from 'react';
import Navbar from './components/Navbar'
import { useNavigate } from "react-router-dom";

export default function AdminDashboard({ setAdminAuthenticationToken }) {

    const navigate = useNavigate();

    return (
        <>

            <Navbar setAdminAuthenticationToken={setAdminAuthenticationToken} />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>Dashboard</h4>
            </div>

        </>
    )
}
